import { useCallback } from 'react';

interface SetItemLocalStorage {
  key: string;
  value: string;
}

interface GetItemLocalStorage {
  key: string;
}

export const useLocalStorage = () => {
  const setLocalStorage = useCallback((item: SetItemLocalStorage) => {
    try {
      if (!item.key || !item.value) {
        throw new Error('empty values');
      }
      localStorage.setItem(item.key, item.value);
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  }, []);

  const removeItemLocalStorage = useCallback((item: GetItemLocalStorage) => {
    try {
      if (!item.key) {
        throw new Error('empty key');
      }
      localStorage.removeItem(item.key);
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  }, []);

  const setInitialStateLocalStorage = useCallback(() => {
    const keys: GetItemLocalStorage[] = [{ key: 'user' }, { key: 'token' }];
    keys.map((key) => removeItemLocalStorage(key));
  }, [removeItemLocalStorage]);

  const clearLocalStorage = useCallback(() => {
    try {
      localStorage.clear();
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
  }, []);

  const getLocalStorage = useCallback(
    (item: GetItemLocalStorage): string | null => {
      try {
        if (!item.key) {
          throw new Error('empty key');
        }
        const value = localStorage.getItem(item.key);
        if (!value) return null;
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      } catch (error) {
        throw new Error(JSON.stringify(error));
      }
    },
    [],
  );

  return {
    setLocalStorage,
    removeItemLocalStorage,
    setInitialStateLocalStorage,
    getLocalStorage,
    clearLocalStorage,
  };
};
